import { CallEffect, PutEffect, SelectEffect, call, put, select } from 'redux-saga/effects';
import serviceLocator, { INDIVIDUAL_PORTAL_SVC } from '@APIs/common/service-locator';

import {
    fetchCommunicationPreferencesFailure,
    fetchCommunicationPreferencesSuccess,
    setCommunicationPreferences,
    startFetchingPreferences
} from '@actions/individualPortal/preferences/communicationPreferencesActionCreators';

import { languagesSaga } from './languages-saga';

import { selectIfCommunicationPreferencesLoaded, selectIfLanguagesLoaded } from '@reducers/appReducer';

// Types

import { CommunicationPreferences } from '@components/ssap/SsapTypes';

export function* executeSagaCallbacks(callbacks: { togglePageReadiness: (status: boolean) => void; toggleExtraDataStatus: (status: boolean) => void }) {
    if (callbacks) {
        const { togglePageReadiness, toggleExtraDataStatus } = callbacks;
        yield call(toggleExtraDataStatus, true);
        yield call(togglePageReadiness, true);
    }
}

export function* communicationPreferencesSaga({ callbacks, shouldForceUpdate = false, skipFailureRedirect = false }): Generator<
    CallEffect<unknown> | PutEffect<{type: string}> | SelectEffect,
    void,
    any
    > {
    try {
        // Check if communication preferences are already loaded
        const isCommunicationPreferencesLoaded: boolean = yield select(selectIfCommunicationPreferencesLoaded);
        // Check if languages are already loaded
        const isLanguagesLoaded: boolean = yield select(selectIfLanguagesLoaded);

        if (isCommunicationPreferencesLoaded && isLanguagesLoaded && !shouldForceUpdate) {
            if (callbacks) {
                yield call(executeSagaCallbacks, callbacks);
            }
            return;
        }

        yield put(startFetchingPreferences());

        const individualPortalService: ReturnType<(...args: any) => any> = yield call(
            serviceLocator,
            INDIVIDUAL_PORTAL_SVC
        );
        if (!isLanguagesLoaded) {
            yield call(languagesSaga, { skipFailureRedirect: false }); //will not skip failure redirect for language api
        }

        if (!isCommunicationPreferencesLoaded || shouldForceUpdate) {
            try {
                const communicationPreferences: { payload: CommunicationPreferences } = yield call([
                    individualPortalService,
                    individualPortalService.getCommunicationPreferences
                ]);
                if (communicationPreferences) {
                    yield put(fetchCommunicationPreferencesSuccess());
                    yield put(setCommunicationPreferences(communicationPreferences.payload));
                } else {
                    yield put(fetchCommunicationPreferencesFailure(skipFailureRedirect));
                }
            } catch {
                yield put(fetchCommunicationPreferencesFailure(skipFailureRedirect));
            }
        }

        if (callbacks) {
            yield call(executeSagaCallbacks, callbacks);
        }
    } catch(e) {
        yield put(fetchCommunicationPreferencesFailure());
    }
}